import Card_left from "../components/CardLeft";

export default function Underholdning() {
  return (
    <section>
      <Card_left >
        <div className="card-right-title">
          Underholdning
        </div>
        <div className="card-right-content">
          <p>
            Melding fra Toastmaster: 
            <br /> <br />
            Hei alle sammen!
            <br /><br />
            Jeg gleder meg masse til å feire Jorid og Erik sammen med dere! 🥳
            <br /><br />
            Det har seg slik at jeg har fått æren av å være toastmaster og jeg skal dermed guide dere igjennom 
            dagen og passe på at dagen går sømmelig for seg.
            <br /><br />
            Hvis du har lyst til å holde tale, arrangere en lek eller bidra med et annet type innslag, burde du ta kontakt med meg på messenger eller på SMS (90628823). Det beste er om du sier i fra så tidlig som mulig 😉
            <br /><br />
            Vi snakkes!
            <br />
            Stein Oskar Hinderaker
          </p>
        </div>
      </Card_left>
    </section>
  );
}